import Swal from "sweetalert2";

export const updateObject = (currentObject, updatedProperties) => {
  return {
    ...currentObject,
    ...updatedProperties,
  };
};

export const formatterCurrency = (value = 0) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const convertFilesDescsNewToBase64 = async (filesDescsNew) => {
  const filesDescsNewBase64 = await Promise.all(
    filesDescsNew.map(async (desc) => {
      const base64File = await fileToBase64(desc.file);
      return {
        ...desc,
        base64File,
      };
    }),
  );
  return filesDescsNewBase64;
};

export const capitalizeFirstLetter = (string) => {
  if (!string) return "";
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const updateArray = (currentArray, updatedProperties) => {
  return [...currentArray, updatedProperties];
};

export const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const setFilterAnd = (params, key, value) => {
  if (params.filterAnd) {
    const filters = params.filterAnd.split(",");
    if (filters.indexOf(`${key}:${value}`) == -1) {
      filters.push(`${key}:${value}`);
      params.filterAnd = filters.join(",");
    }
  } else {
    params.filterAnd = `${key}:${value}`;
  }
  return params;
};

export const handleResponse = (response, onSuccess, onError = (err) => {}, mode = undefined) => {
  if (onSuccess) {
    response.then(onSuccess).catch(onError);
  } else if (mode === "generic") {
    response.then(onSuccess).catch((err) => {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "There's an issue with the system. Please contact IT Support for assistance!",
      });
    });
  }
  return response;
};

export const handlerFormError = (data) => {
  if (data && data.errors) {
    const [key] = Object.keys(data.errors || {});
    const message = data.errors[key];
    Swal.fire({
      icon: "error",
      title: "Error",
      text: message[0],
    });
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: (data && data.message) || "",
    });
  }
};

export const cleanCurrency = (currency) => {
  // Remove any non-numeric characters, except for a dot for decimals
  const cleanNumber = currency.replace(/[^\d.-]/g, "");
  return cleanNumber;
};

export const formatCurrency = (value, currency = "") => {
  if (!value) return currency + "0";
  const number = parseInt(value.replace(/[^0-9]/g, ""), 10); // remove non-numeric characters
  return isNaN(number) ? currency + "0" : `${currency}${number.toLocaleString()}`;
};

export const sizeOfArray = function (array) {
  let size = 0;

  for (let key in array) {
    if (array.hasOwnProperty(key)) {
      size++;
    }
  }

  return size;
};

export const getMultipartOptions = (axios) => {
  const headers = axios.defaults.headers;
  return { headers: { ...headers, "Content-Type": "multipart/form-data" } };
};

export const isValidUrl = (url) => {
  try {
    new URL(url);
  } catch (e) {
    console.error(e);
    return false;
  }
  return true;
};

export const importProductAlert = (data) => {
  return `
    <div>
        <div style="text-align:left">
            <table>
                <tr>
                    <td style='padding: 5px'>Import Success</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.total_imported || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Brand Error</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.brand_error?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Invalid Entity</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.invalid_entity?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Invalid Model Code</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.invalid_model_code?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Invalid Group Code</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.invalid_group_code?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Prefix Error</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.prefix_error?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>SKU Format Invalid</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.sku_format_invalid?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Duplicate</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.duplicate?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>SKU Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.sku_not_found?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Segment Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.segment_not_found?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Category Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.category_not_found?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Sub Category Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.subcategory_not_found?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Sub Sub Category Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.subsubcategory_not_found?.length || 0}</td>
                </tr>
                <tr>
                    <td style='padding: 5px'>Brand Not Found</td>
                    <td style='padding: 5px'>:</td>
                    <td style='padding: 5px'>${data.error?.brand_not_found?.length || 0}</td>
                </tr>
            </table>
        </div>
    </div>`;
};

export const sapSyncAlert = (data) => {
  let tArray = [];
  tArray.push("CardCode is required!");
  tArray.push("CardName is required!");
  tArray.push("Category is required!");

  let html = `<div style = 'text-align: left; height: ${data?.error ? "400px; " : "220px; "} overflow: auto; overflow-y: sroll' class='p-2 swal-html'>`;
  html += data?.success?.product ? `<span style='color:green'><b>SUCCESS</b></span></br></br>` : "";
  (data?.success?.product || []).map((item) => {
    html += `<div class='card p-2'><b>${item}</b></div>`;
  });
  html += data?.error?.product ? `<span style='color: red'><b>ERROR PRODUCT</b></span><hr>` : "";
  (data?.error?.product || []).map((item) => {
    html += `
        <div class='card p-2'>
            <div style='margin-bottom: 10px'>
                <label>Item Code:</label>
                <div style='margin-top: -10px'>${item.item_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Error Code:</label>
                <div style='margin-top: -10px'>${item.error_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Message:</label>`;
    if (item.error_code == "Internal Error") {
      html += `<div style='margin-top: -10px'><ul>`;
      item.message?.map((itm) => (html += `<li class="mt-1" key=${itm}> ${itm} </li>`));
      html += `</ul></div>`;
    } else {
      html += `<div style='margin-top: -10px'>${item.message}</div>`;
    }
    html += `</div>
        </div>
    `;
  });
  html += data?.error?.bsni ? `<span style='color: red'><b>ERROR BARCODE SNI</b></span><hr>` : "";
  (data?.error?.bsni || []).map((item) => {
    html += `
        <div class='card p-2'>
            <div style='margin-bottom: 10px'>
                <label>Item Code:</label>
                <div style='margin-top: -10px'>${item.item_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Error Code:</label>
                <div style='margin-top: -10px'>${item.error_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Message:</label>
                <div style='margin-top: -10px'>${item.message}</div>
            </div>
        </div>
    `;
  });
  html += data?.error?.bqr ? `<span style='color: red'><b>ERROR QR CODE</b></span><hr>` : "";
  (data?.error?.bqr || []).map((item) => {
    html += `
        <div class='card p-2'>
            <div style='margin-bottom: 10px'>
                <label>Item Code:</label>
                <div style='margin-top: -10px'>${item.item_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Error Code:</label>
                <div style='margin-top: -10px'>${item.error_code}</div>
            </div>
            <div style='margin-bottom: 10px'>
                <label>Message:</label>
                <div style='margin-top: -10px'>${item.message}</div>
            </div>
        </div>
    `;
  });
  html += `</ > `;

  return html;

  // let tArray = [];
  // tArray.push("CardCode is required!");
  // tArray.push("CardName is required!");
  // tArray.push("Category is required!");

  // return `<div style = 'text-align: left; height: ${data?.error ? '400px; ' : '220px; '} overflow: auto; overflow-y: sroll' class='p-2 swal-html'>
  // ${data?.success?.product ? `<span style='color:green'><b>SUCCESS</b></span></br></br>` : ''}
  // ${data?.success?.product
  //     ?
  //     data.success.product.map(item => {
  //         return `<div class='card p-2'><b>${item}</b></div>`
  //     }) : ''
  // }
  // ${data?.error?.product ? `<span style='color: red'><b>ERROR PRODUCT</b></span><hr>` : ''}
  // ${data?.error?.product
  //         ?
  //         data.error.product.map(item => {
  //             return `
  //             <div class='card p-2'>
  //                 <div style='margin-bottom: 10px'>
  //                     <label>Item Code:</label>
  //                     <div style='margin-top: -10px'>${item.item_code}</div>
  //                 </div>
  //                 <div style='margin-bottom: 10px'>
  //                     <label>Error Code:</label>
  //                     <div style='margin-top: -10px'>${item.error_code}</div>
  //                 </div>
  //                 <div style='margin-bottom: 10px'>
  //                     <label>Message:</label>
  //                     ${item.error_code == 'Internal Error' ? `<div style='margin-top: -10px'><ul>${item.message?.map(itm => `<li key=${itm}> ${itm} </li>`)}</ul></div>` : `<div style='margin-top: -10px'>${item.message}</div>`}
  //                 </div>
  //             </div>
  //         `}) : ''
  //     }
  //     ${data?.error?.bsni ? `<span style='color: red'><b>ERROR BARCODE SNI</b></span><hr>` : ''}
  //     ${data?.error?.bsni
  //         ?
  //         data.error.bsni.map(item => {
  //             return `
  //         <div class='card p-2'>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Item Code:</label>
  //                 <div style='margin-top: -10px'>${item.item_code}</div>
  //             </div>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Error Code:</label>
  //                 <div style='margin-top: -10px'>${item.error_code}</div>
  //             </div>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Message:</label>
  //                 <div style='margin-top: -10px'>${item.message}</div>
  //             </div>
  //         </div>
  //     `}) : ''
  //     }
  //     ${data?.error?.bqr ? `<span style='color: red'><b>ERROR QR CODE</b></span><hr>` : ''}
  //     ${data?.error?.bqr
  //         ?
  //         data.error.bqr.map(item => {
  //             return `
  //         <div class='card p-2'>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Item Code:</label>
  //                 <div style='margin-top: -10px'>${item.item_code}</div>
  //             </div>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Error Code:</label>
  //                 <div style='margin-top: -10px'>${item.error_code}</div>
  //             </div>
  //             <div style='margin-bottom: 10px'>
  //                 <label>Message:</label>
  //                 <div style='margin-top: -10px'>${item.message}</div>
  //             </div>
  //         </div>
  //     `}) : ''
  //     }
  // </ > `;
};

export const webSyncAlert = (data) => {
  let html = `<div style = 'text-align: left; height: ${
    data?.errors.length > 0 ? "400px; " : "220px; "
  } overflow: auto; overflow-y: sroll' class='p-2 swal-html'>
            <span style='color: green'><b>Success Sync: ${data?.success}</b></span><hr>`;
  html += data?.errors ? `<span style='color: red'><b>Failed Sync: ${data?.failed}</b></span><hr>` : "";
  (data?.errors || []).map((item) => {
    html += `<div class='card p-2'><div style='margin-bottom: 10px'><label>Item Code:</label><div>${item.item_code}</div></div><div style='margin-bottom: 10px'>
                <label>Message:</label><div><ul>`;
    Object.keys(item.error || {}).map((key) => (html += `<li class="mt-1" key=${key}>${item.error[key]}</li>`));
    html += `</ul></div></div></div>`;
  });
  html += `</ > `;

  return html;
};

export const typeFeatureFailed = (data) => {
  let html = data ? `<span style='color: red'><b>Failed Deleted</b></span><hr>` : "";
  data.map((item) => {
    html += `
        <div class='card p-2'>
                <div style='margin-bottom: 10px'>
                    <label>Feature Name:</label>
                    <div style='margin-top: -10px'>${item.feature_name}</div>
                </div>
                <div style='margin-bottom: 10px'>
                    <label>Type Name:</label>
                    <div style='margin-top: -10px'>${item.type_name}</div>
                </div>`;
    html += `
        </div>
    `;
  });

  return html;
};

export const previewFile = async (file, callback) => {
  const reader = new FileReader();

  reader.onload = function (e) {
    const dataURL = e.target.result;
    callback(file, dataURL);
  };

  reader.readAsDataURL(file);
};

export const product_class_data = [
  {
    value: "GOOD",
    label: "GOOD",
  },
  {
    value: "BETTER",
    label: "BETTER",
  },
  {
    value: "BEST",
    label: "BEST",
  },
];
